export default {
    namespaced: true,
    state: {
        siteId: '', // идентификтаор сайта для обработчика запросов
        parameters: '',// параметры для обработчика запросов
        template: '',// шаблон для обработчика запросов
        rand: '',// рандомная строка компонента для обработчика запросов
        ajaxUrl: '', // адрес запросов
        isAuthorized: false, // пользваотель авторизован
        reloadAfterAuth: false, // нужно ли перезагружать страницу после успешнйо авторизации

        email: '', // введенный email

        sendCodeLoader: false, // показ лоадера что код оптравляется
        sendCodeTimeout: false, // количество секунд для ожидания следующей отправки

        captchaSid: false, //идентфиикатор капи
        captchaSrc: false, //ссылк ана кратинку
        captchaWord: false, //введеные символы с картинки
        captchaLength: 5, //длина ожидаемого кода
        captchaLoader: false, //загружается новая

        message: false, // сообщение
        error: false, // сообщение об ошибкой

        isShowCodeBlock: false, // нужно показать блок проверки кода

        code: false, //введенный код
        codeError: false, // если есть ошибка с кодом
        codeLength: 4,// длина проверяемого кода

        checkCodeLoader: false, //код проверяется
        expandData: {},
    },
    mutations: {
        setValues(state, data) {
            let key;
            for (key in data) {
                state[key] = data[key];
            }
        },
        setExpandData(state, data) {
            let key;
            for (key in data) {
                state.expandData[key] = data[key];
            }
        },
        /**
         * Устнаовка email адреса
         * @param state
         * @param value
         */
        setEmail(state, value) {
            state.email = value;
        },

        /**
         * Показ лоадера отправки кода или нет
         * @param state
         * @param flag
         */
        setSendCodeLoader(state, flag) {
            state.sendCodeLoader = !!flag;
        },
        /**
         * установка сообщения
         * @param state
         * @param message
         */
        setMessage(state, message) {
            state.message = message;
            state.error = false;
        },
        /**
         * установка сообщения
         * @param state
         * @param message
         */
        setError(state, message) {
            state.message = message;
            state.error = true;
        },
        /**
         * установка сообщения
         * @param state
         */
        resetMessage(state) {
            state.message = false;
            state.error = false;
        },
        /**
         *  Показать блок ввода кода
         * @param state
         */
        showCodeBlock(state) {
            state.isShowCodeBlock = true;
        },
        /**
         * Показать блок ввода email адреса
         * @param state
         */
        hideCodeBlock(state) {
            state.isShowCodeBlock = false;
        },
        /**
         * Установка интервала ожидания между отправками кода
         * @param state
         * @param time
         */
        setSendCodeTimeout(state, time) {
            state.sendCodeTimeout = +time;
        },
        /**
         * Устновит длину временного кода
         * @param state
         * @param {number} length
         */
        setCodeLength(state, length) {
            state.codeLength = +length;
        },
        /**
         * Скрыть капчу
         * @param state
         */
        hideCaptcha(state) {
            state.captchaSrc = false;
        },
        /**
         * Скрыть капчу
         * @param state
         */
        resetCaptcha(state) {
            state.captchaSrc = false;
            state.captchaSid = false;
            state.captchaWord = false;
            state.captchaLoader = false;
        },
        /**
         * Сброс отображения капчи
         * @param state
         * @param src
         */
        setCaptchaSrc(state, src) {
            state.captchaSrc = src;
        },
        /**
         * Введеный код капчи
         * @param state
         * @param word
         */
        setCaptchaWord(state, word) {
            state.captchaWord = word;
        },
        /**
         * Введеный код капчи
         * @param state
         * @param {bool} flag
         */
        setCaptchaLoader(state, flag) {
            state.captchaLoader = !!flag;
        },
        /**
         * Указываем введенный код
         * @param state
         * @param {string} code
         */
        setCode(state, code) {
            state.code = code;
        },
        /**
         * Указываем введенный код
         * @param state
         * @param {string|false} msg
         */
        setCodeError(state, msg) {
            state.codeError = msg;
        },
        /**
         * Показываем . скрываем показ лоадера
         * @param state
         * @param {bool} flag
         */
        setCheckCodeLoader(state, flag) {
            state.checkCodeLoader = !!flag;
        },
    },
    getters: {},
    actions: {
        parseError({state, commit}, error) {
            switch (error.code) {
                case 'BXMAKER_AUTHUSERPHONE_ERROR_INVALID_EMAIL': {
                    commit('resetCaptcha');
                    commit('hideCodeBlock');
                    break;
                }
                case 'BXMAKER_AUTHUSEREMAIL_NEED_WAIT_TIMEOUT': {
                    commit('resetCaptcha');
                    commit('showCodeBlock');
                    commit('setSendCodeTimeout', error.more.timeout);
                    break;
                }
                case 'BXMAKER_AUTHUSEREMAIL_NEED_CAPTCHA': {
                    commit('setValues', {
                        captchaSid: error.more.captchaSid,
                        captchaSrc: error.more.captchaSrc,
                        captchaWord: '',
                        captchaLength: error.more.captchaLength,
                    });

                    break;
                }
                case 'BXMAKER_AUTHUSERPHONE_ERROR_CODE_INVALID':
                case 'BXMAKER_AUTHUSEREMAIL_ERROR_CODE': {
                    commit('setCode', '');
                    commit('setCodeError', error.msg);
                    break;
                }
                default: {
                    commit("setError", error.msg);
                    break;
                }
            }
        },
        /**
         * Запрос отправки кода на email
         * @param state
         * @param commit
         * @param dispatch
         */
        sendCode({state, commit, dispatch}) {
            commit('resetMessage');
            commit('hideCaptcha');
            commit('setSendCodeLoader', true);

            BX.ajax({
                url: state.ajaxUrl,
                method: 'POST',
                dataType: 'json',
                timeout: 10,
                async: true,
                cache: false,
                data: {
                    method: 'sendCode',
                    sessid: BX.bitrix_sessid(),
                    siteId: state.siteId,
                    template: state.template,
                    parameters: state.parameters,

                    email: state.email,
                    captcha_sid: state.captchaSid,
                    captcha_word: state.captchaWord,
                },
                onsuccess: (r) => {
                    if (r.response) {

                        if (r.response['length']) {
                            commit('setCodeLength', r.response.length);
                        }
                        if (r.response['timeout']) {
                            commit('setSendCodeTimeout', r.response.timeout);
                        }
                        commit('resetCaptcha');
                        commit('showCodeBlock');

                    } else {
                        dispatch('parseError', r.error);
                    }

                    commit('setSendCodeLoader', false);
                },
                onfailure: (e) => {
                    commit('setSendCodeLoader', false);
                }
            });

        },
        /**
         * Запрос отправки кода на email
         * @param state
         * @param commit
         * @param dispatch
         */
        checkCode({state, commit, dispatch}) {
            commit('resetMessage');
            commit('hideCaptcha');
            commit('setCheckCodeLoader', true);

            BX.ajax({
                url: state.ajaxUrl,
                method: 'POST',
                dataType: 'json',
                timeout: 10,
                async: true,
                cache: false,
                data: {
                    method: 'checkCode',
                    sessid: BX.bitrix_sessid(),
                    siteId: state.siteId,
                    template: state.template,
                    parameters: state.parameters,
                    email: state.email,
                    code: state.code,
                    captcha_sid: state.captchaSid,
                    captcha_word: state.captchaWord,
                },
                onsuccess: (r) => {
                    if (r.response) {

                        commit('setValues', {
                            isAuthorized: true
                        });

                        BX.Vue.event.$emit('BXmakerAuthuseremailCheckCodeSuccess', {
                            'response': r.response,
                            'rand': state.rand,
                        });

                        dispatch('reload');

                    } else {
                        dispatch('parseError', r.error);
                    }
                    commit('setCheckCodeLoader', false);
                },
                onfailure: (e) => {
                    commit('setCheckCodeLoader', false);
                }
            });

        },

        /**
         * Запрос новой капчи
         * @param state
         * @param commit
         */
        captchaRefresh({state, commit}) {
            commit('resetMessage');
            commit('setCaptchaLoader', true);

            BX.ajax({
                url: state.ajaxUrl,
                method: 'POST',
                dataType: 'json',
                timeout: 10,
                async: true,
                cache: false,
                data: {
                    method: 'refreshCaptcha',
                    sessid: BX.bitrix_sessid(),
                    siteId: state.siteId,
                    template: state.template,
                    parameters: state.parameters,
                },
                onsuccess: (r) => {
                    if (r.response) {

                        commit('setValues', {
                            captchaSid: r.response.captchaSid,
                            captchaSrc: r.response.captchaSrc,
                            captchaLength: r.response.captchaLength,
                            captchaWord: '',
                        });

                    } else {
                        commit("setError", r.error.msg);
                    }

                    commit('setCaptchaLoader', false);
                },
                onfailure: (e) => {
                    commit('setCaptchaLoader', false);
                }
            });

        },
        /**
         * Перезагрузит страницу  если включена опция reloadAfterAuth
         * @param state
         */
        reload({state}) {
            if (state.reloadAfterAuth) {
                location.reload();
            }
        }
    },
};

